<template>
    <div class="row">
        <div class="col-12 col-md-12 note-head">
            <div class="note-title">
                <h4>{{ note.name }}</h4>
            </div>
            <div class="note-btn d-flex align-items-center" v-if="!note.isHideAddBtn">
                <button @click="onOpenModal(note, index)" type="button" class="btn btn-outline-primary btn-sm btn-block">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
        </div>
        <div class="col-21">
            <hr class="mt-0">
        </div>
        <div class="col-12 col-md-12 note-body">
            <div class="card">
                <div class="card-body">
                    <div class="medicine" v-for="(item, noteIndex) in note.selectedNotes" :key="noteIndex">
                        <div class="medicine-name">
                             <div>
                               <span class="sr-no">{{ noteIndex + 1 }}. </span>
                               <span class="name">{{ item.name }}</span>
                             </div>
                             <div>
                               <span>{{ item.dentition ? '(' + item.dentition.join(", ").toUpperCase() + ')' : ''}}</span>
                               <span>
                                <button class="btn btn-sm" @click="onOpenDentitionModal(item, noteIndex)">
                                    <i class="fas fa-teeth"></i>
                                </button>
                            </span>
                             </div>

                        </div>
                        <div @click="onRemoveNote(item, noteIndex)" class="action" v-if="!note.isHideAddBtn">
                            <i class="far fa-times-circle close"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-12 note-footer pb-2" v-if="from === 'group-template'">
            <SubmitCancelBtn
                class="text-right"
                @onSubmit="onSaveTemplate"
                :loading="loading"
                :isHideCancelBtn="true"
                :disabled="note.selectedNotes.length === 0"
            />
        </div>
        <Loader v-if="loading"/>

        <AddDentitionModal
            v-if="isOpenDentitionModal"
            v-model:isOpenModal="isOpenDentitionModal"
            :dentition="dentition"
            @onSaveDentition="onSaveDentition"
            :dentitionItem="dentitionItem"
        />
    </div>
</template>

<script setup>
import { inject } from "vue";
import { ref } from "vue"
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import { useRoute } from "vue-router";
import { convertToTitleCase } from '@/services/utils/global';
import Loader from '@/components/atom/LoaderComponent'
import AddDentitionModal from '@/components/molecule/company/dental-os/service/middle-header/AddDentitionModal.vue';

const props = defineProps({
    note: Object,
    index: {
        type: Number,
        default: -1,
    },
    from: {
        type: String,
        default: ''
    },
    dentition: {
      type: Object || null,
      default: () => {}
    },
    dentitionType: {
      type: String || null,
      default: null,
    },
})

const emit = defineEmits(['openModal'])
const input = ref(null)
const route = useRoute();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false);
const dentitionItem = ref(null);

const isOpenDentitionModal = ref(false)
const onOpenModal = (note, index = -1) => {
    if(note.value){
        note.name = convertToTitleCase(note.value);
    }
    emit('openModal', {note, index})
}

const onSaveDentition = (selectedDentition) => {
    dentitionItem.value.dentition = selectedDentition;
}

const onOpenDentitionModal = (item, index) => {
    dentitionItem.value = item;
    isOpenDentitionModal.value = true
}

const onRemoveNote = (noteName, selectedIndex) => {
    props.note.selectedNotes.splice(selectedIndex, 1)

    const index = props.note.newNotesByDoctor.indexOf(noteName);
    if(index < 0) return;

    props.note.newNotesByDoctor.splice(index);
}

</script>

<style scoped>
.note-title {
    min-width: 200px;
}
.note-body .card-body{
    padding: 0 2%;
}
.note-head {
    display: flex;
    margin-top: 2%;
    justify-content: space-between;
    margin-bottom: 1%;
}
.action .close {
    color: red;
    cursor: pointer;
}
.note-body .card {
    background: #f9f9f9;
    min-height: 100px;
    margin-bottom: 1rem;
}
.medicine {
    display: flex;
    justify-content: space-between;
    margin: 3% 0;
    align-items: center;
    position: relative;
}
</style>